module.exports = __webpack_public_path__ + "static/img/7.53bbf20.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/7.png
// module id = ldpo
// module chunks = 0